module.exports = __webpack_public_path__ + "static/img/er.8ed15cbe.png";